import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledButton = styled.button`
  width: ${({ width }) => width || '100%'};
  height: 50px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.error};
  color: ${({ theme }) => theme.color.white};
  &:hover:enabled {
    background-color: #d10a52;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  transition: all 0.3s ease;
`;

const StyledBorderedButton = styled.button`
  width: ${({ width }) => width || '100%'};
  height: 50px;
  background-color: transparent;
  border-radius: 2px;
  border: solid 1px #c7baf1;
  cursor: pointer;
  color: #c7baf1;
  &:hover {
    background-color: rgba(34, 9, 108, 0.5);
    color: ${({ hoverTextColor }) => hoverTextColor};
    border: solid 1px #c7baf1;
  }
  transition: all 0.3s ease;
`;

const Button = ({
  children, disabled, type, width, buttonShape, onClick, hoverTextColor, className,
}) => {
  if (buttonShape === 'bordered') {
    return (
      <StyledBorderedButton
        className={className}
        hoverTextColor={hoverTextColor}
        width={width}
        type={type}
        onClick={onClick ? () => onClick() : undefined}
      >
        {children}
      </StyledBorderedButton>
    );
  }
  return (
    <>
      <StyledButton
        className={className}
        onClick={onClick ? () => onClick() : undefined}
        width={width}
        type={type}
        disabled={disabled}
      >
        {children}
      </StyledButton>
    </>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  type: PropTypes.string,
  width: PropTypes.string,
  buttonShape: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  hoverTextColor: PropTypes.string,
};

Button.defaultProps = {
  type: '',
  width: '',
  buttonShape: '',
  disabled: false,
  onClick: undefined,
  className: '',
  hoverTextColor: '',
};

export default Button;
